<script>
    /*
    	ServiceFieldsGroup3.svelte
        
        Additional Info - 11 fields

        Expandable/Collapsible and contains a predetermined set of DataFields
    */

    import { onMount } from 'svelte';
    import { NECESSARY_DOCS, NECESSARY_MATS, ACCEPTS_INSURANCE, COST_FREE } from '../../common/constants.js';
    import { ADDITIONAL_INFO, ELIGIBILITY, AVAILABILITY, LANGUAGES, REVIEWED, LAST_VALID } from '../../common/constants.js';
    import { intToYesNo, shallowArraysEqual } from '../../common/utils.js';

    // new 09/01 - for populating API-aware fields
	import { fieldPresetsStore } from '../../stores/FieldPresetsStore.js';
	// import { fetchAllFieldsPresets, fetchSingleFieldPresets } from '../../stores/FieldPresetsStore.js';

    
    // TCARE components
    import DataTextField from '../data-fields/DataTextField.svelte';
    import DataSelectField from '../data-fields/DataSelectField.svelte';
    import ApiArrayField from '../data-fields/ApiArrayField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';

    // SMUI components

    // const FIELDS = [ 
    //     NECESSARY_DOCS, NECESSARY_MATS, INSURANCE_ACCEPT, NEXT_STEPS, COST_FREE,
    //     ELIGIBILITY, AVAILABILITY, LANGUAGES, REVIEWED, LAST_VALID 
    // ];
    const GROUP_TITLE = 'Additional Information';
    

    export let store;                   // store is a Service store - not just data!
    export let leftService;
    export let rightService;
    export let onCopyValue;
    export let isEditable;
    export let isOpen;
    export let showDiffs;               // bypass the strike-through and highlighting

    $: apiData = $store.apiData;
    $: isExpanded = isOpen;

    onMount(() => {
    })

    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }


    // TODO: could move these to common area
    const isFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return leftService[propName] !== rightService[propName];
    }

    const isArrayFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return !shallowArraysEqual(leftService[propName], rightService[propName]);
    }

    // const getDiffCount = () => {
    //     let diffs = 0;
    //     for (const field of FIELDS) {
    //         if (isFieldDiff(field)) diffs++;
    //     }
    //     return diffs;
    // }


</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">
    
    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />

    {#if apiData && isExpanded}
        <div class="fields-area">

            <!-- left and right blocks in a fluid row -->
            <div class="flex-row ai-start fluid">

                <div class="flex-block w-49">
                    <!-- 09/01 - new API-aware field type -->
                    <ApiArrayField
                        bind:value={apiData[ADDITIONAL_INFO]}
                        choices={$fieldPresetsStore[ADDITIONAL_INFO]}
                        {store}
                        propName={ADDITIONAL_INFO}
                        label={'Additional Info'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(ADDITIONAL_INFO)}
                        isNewDiff={isArrayFieldDiff(ADDITIONAL_INFO)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[ADDITIONAL_INFO]}
                        {showDiffs}
                        isUserInput={true}
                        isUserSelect={true}
                    />

                    <ApiArrayField
                        bind:value={apiData[NECESSARY_DOCS]}
                        choices={$fieldPresetsStore[NECESSARY_DOCS]}
                        {store}
                        propName={NECESSARY_DOCS}
                        label={'Documents'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(NECESSARY_DOCS)}
                        isNewDiff={isArrayFieldDiff(NECESSARY_DOCS)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[NECESSARY_DOCS]}
                        {showDiffs}
                        isUserInput={true}
                        isUserSelect={true}
                    />

                    <ApiArrayField
                        bind:value={apiData[NECESSARY_MATS]}
                        choices={$fieldPresetsStore[NECESSARY_MATS]}
                        {store}
                        propName={NECESSARY_MATS}
                        label={'Materials'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(NECESSARY_MATS)}
                        isNewDiff={isArrayFieldDiff(NECESSARY_MATS)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[NECESSARY_MATS]}
                        {showDiffs}
                        isUserInput={true}
                        isUserSelect={true}
                    />

                    <!--
                    <ApiArrayField
                        bind:value={apiData[INSURANCE_ACCEPT]}
                        choices={$fieldPresetsStore[INSURANCE_ACCEPT]}
                        {store}
                        propName={INSURANCE_ACCEPT}
                        label={'Insurance'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(INSURANCE_ACCEPT)}
                        isNewDiff={isArrayFieldDiff(INSURANCE_ACCEPT)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[INSURANCE_ACCEPT]}
                        {showDiffs}
                        isUserInput={true}
                        isUserSelect={true}
                    />
                    -->

                    <!-- changes to yes/no 11/1 per Lindsey -->
                    <!-- this is NOT the correct field type -->
                    <!--
                    <DataSelectField
                        bind:value={apiData[INSURANCE_ACCEPT]}
                        choices={$fieldPresetsStore[INSURANCE_ACCEPT]}
                        propName={INSURANCE_ACCEPT}
                        label={'Insurance Accepted'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(INSURANCE_ACCEPT)}
                        isNewDiff={isFieldDiff(INSURANCE_ACCEPT)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    -->

                    <!-- 'yes', 'no', 'unknown' 11/8 per Connor -->
                    <DataSelectField
                        bind:value={apiData[ACCEPTS_INSURANCE]}
                        choices={$fieldPresetsStore[ACCEPTS_INSURANCE]}
                        propName={ACCEPTS_INSURANCE}
                        label={'Accepts Insurance'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(ACCEPTS_INSURANCE)}
                        isNewDiff={isFieldDiff(ACCEPTS_INSURANCE)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />

                    <ApiArrayField
                        bind:value={apiData[LANGUAGES]}
                        choices={$fieldPresetsStore[LANGUAGES]}
                        {store}
                        propName={LANGUAGES}
                        label={'Languages'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(LANGUAGES)}
                        isNewDiff={isArrayFieldDiff(LANGUAGES)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[LANGUAGES]}
                        {showDiffs}
                        isUserInput={false}
                        isUserSelect={true}
                    />

                    <DataSelectField
                        bind:value={apiData[AVAILABILITY]}
                        choices={$fieldPresetsStore[AVAILABILITY]}
                        propName={AVAILABILITY}
                        label={'Availability'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(AVAILABILITY)}
                        isNewDiff={isFieldDiff(AVAILABILITY)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>

                <div class="flex-block w-49">

                    <!--
                    <DataTextField
                        bind:value={apiData[NEXT_STEPS]}
                        propName={NEXT_STEPS}
                        label={'Next Steps'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(NEXT_STEPS)}
                        isNewDiff={isFieldDiff(NEXT_STEPS)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    -->

                    <DataTextField
                        bind:value={apiData[COST_FREE]}
                        propName={COST_FREE}
                        label={'Approx. Cost'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(COST_FREE)}
                        isNewDiff={isFieldDiff(COST_FREE)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />

                    <DataTextField
                        bind:value={apiData[ELIGIBILITY]}
                        propName={ELIGIBILITY}
                        label={'Eligibility'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(ELIGIBILITY)}
                        isNewDiff={isFieldDiff(ELIGIBILITY)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />

                    <!-- always read-only until Boolean field type -->
                    <DataTextField
                        value={intToYesNo(apiData[REVIEWED])}
                        propName={REVIEWED}
                        label={'Is Reviewed'}
                        isEditable={false}
                        isOrigDiff={isFieldDiff(REVIEWED)}
                        isNewDiff={isFieldDiff(REVIEWED)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        showDiffs={false}
                    />
                    
                    <DataTextField
                        bind:value={apiData[LAST_VALID]}
                        propName={LAST_VALID}
                        label={'Last Validated'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(LAST_VALID)}
                        isNewDiff={isFieldDiff(LAST_VALID)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>
            </div>      <!-- end flex-row -->
        </div>      <!-- end fields-area -->

    {/if}
</div>
